module.exports = __webpack_public_path__ + "src/assets/cn.c5f43905.png";